export default __webpack_public_path__ + "static/hirschapotheke-d2f2ffda0fffcdbd41cd71fa87c0398c.jpg";